function u(r) {
  let l;
  function a() {
    if (r.value == null) return;
    const { selectionStart: e, selectionEnd: t, value: n } = r.value;
    if (e == null || t == null) return;
    const s = n.slice(0, Math.max(0, e)), o = n.slice(Math.max(0, t));
    l = {
      selectionStart: e,
      selectionEnd: t,
      value: n,
      beforeTxt: s,
      afterTxt: o
    };
  }
  function c() {
    if (r.value == null || l == null) return;
    const { value: e } = r.value, { beforeTxt: t, afterTxt: n, selectionStart: s } = l;
    if (t == null || n == null || s == null)
      return;
    let o = e.length;
    if (e.endsWith(n))
      o = e.length - n.length;
    else if (e.startsWith(t))
      o = t.length;
    else {
      const f = t[s - 1], i = e.indexOf(f, s - 1);
      i !== -1 && (o = i + 1);
    }
    r.value.setSelectionRange(o, o);
  }
  return [a, c];
}
export {
  u as useCursor
};
